/**
 * Webful In-App Analytics — Utility Module
 *
 * Centralised wrapper around the global window.webful SDK.
 * The SDK script is loaded asynchronously in index.html, so
 * every call uses optional chaining to avoid errors if the
 * script has not finished loading yet.
 */

/**
 * Identify the current user after login / profile load.
 * @param {string|number} userId - Internal, stable user ID from the DB.
 * @param {Object} [traits] - Optional non-PII attributes (plan, role…).
 */
export const webfulIdentify = (userId, traits) => {
	window.webful?.identify(userId, traits);
};

/**
 * Track a product event.
 * @param {string} eventName - snake_case event name (e.g. 'label_shared').
 * @param {Object} [properties] - Optional scalar properties.
 */
export const webfulTrack = (eventName, properties) => {
	window.webful?.track(eventName, properties);
};

/**
 * Reset tracking state on logout.
 * Must be called before the page navigates away.
 */
export const webfulReset = () => {
	window.webful?.reset();
};
